export default __webpack_public_path__ + "media/images/brighteon-social/tutorial/Brighteon-Social-Notifications-Settings-e6a33b347d7cb916431fa73733b37d20.png";